import { ConditionType } from '@amplify/amp-module';

const cleanString = (str) => `${str}` ?? '';

export const evaluateCondition = ({ conditionValue, storageValue }, conditionType) => {
  switch (conditionType) {
    case ConditionType.contains:
      return cleanString(storageValue).includes(cleanString(conditionValue));
    case ConditionType.equals:
      return cleanString(storageValue) === cleanString(conditionValue);
    case ConditionType.hasNotValue:
      return !storageValue;
    case ConditionType.hasValue:
      return !!storageValue;
    case ConditionType.notEquals:
      return cleanString(storageValue) !== cleanString(conditionValue);
    default:
      break;
  }
  return false;
};
